import { InjectionToken } from '@angular/core';

import { IUserDetailsTabPlugin } from '../interfaces/user-details-tab-plugin';

export const USER_DETAILS_TAB_PLUGIN = new InjectionToken<IUserDetailsTabPlugin[]>('UserDetailsTabPlugin');
